import Box from '@mui/material/Box';
import { msgTypes } from 'constants/msgTypes';
import { FinancialProtectionMessageModel } from 'model/screensModels/FinancialProtectionMessageModel';
import { InvoiceManagementModel } from 'model/screensModels/InvoiceManagementModel';
import { PaginatorModel } from 'model/utilModels/PaginatorModel';
import * as React from 'react';
import { useState } from 'react';
import { useLocation } from "react-router-dom";
import { FinancialProtectionMessageService } from 'services/menu/financialProtectionMessage/FinancialProtectionMessageService';
import CreateInvoice from './CreateInvoice';
import InvoiceList from './InvoiceList';



export default function InvoiceManagement() {
 
  const [updateValue, setUpdateValue] = React.useState(new InvoiceManagementModel());
  const [flag, setFlag] = useState(false);
  const location = useLocation();
  const [recentGuidelinesMessage, setRecentGuidelinesMessage] = useState(new FinancialProtectionMessageModel());
   const [isEditMode, setIsEditMode] = useState(false);
 

  React.useEffect(() => {
    getParamData();
    loadRecentGuidelineMessage();
  }, [])

  const getParamData = async () => {
    try {
      const companyId = location.state?.selectedCompanyId
      if (companyId != undefined) {
        setFlag(true)
        const invoiceModel = new InvoiceManagementModel()
        invoiceModel.fromCompanyId = companyId;
        setUpdateValue(invoiceModel);
      }
    } catch (error) {
    }
  }

  //to get update record value
  const getUpdateRecordValue = (invoiceManagementModel: InvoiceManagementModel) => {
    setIsEditMode(true);
    setUpdateValue(invoiceManagementModel);
  }

  const addInvoice = () => {
    setFlag(true)
    setIsEditMode(false); // Reset edit mode
    setUpdateValue(new InvoiceManagementModel());
  }

  //Prepare request body 
  const prepareRequestDataForGuidelines = () => {
    const requestBody = new PaginatorModel();
    requestBody.pageNumber = 0;
    requestBody.pageSize = 1;
    return requestBody;
  }

  //Get recent guidelines list
  const loadRecentGuidelineMessage = async () => {
    const requestBody = prepareRequestDataForGuidelines();
    const res = await FinancialProtectionMessageService.getFinancialMessageList(requestBody);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      if (res.data !== '') {
        setRecentGuidelinesMessage(res.data.tbody[0]);
      }else{
        setRecentGuidelinesMessage(new FinancialProtectionMessageModel());
      }
    }
  }


  return (
    <div>
      <Box sx={{ width: '100%' }} className="container">
        <Box>
     
          <div className="content-subheader">
            {!flag ? (
              <h2 className="mr-3 font-weight-bolder">Invoices </h2>
            ) : (
              <h2 className=" font-weight-bolder mr-3">{isEditMode ? 'Edit Invoice' : 'Create Invoice'}</h2>
            )}
            {!flag && <button className="btn primary" onClick={addInvoice}>Add Invoice</button>}
          </div>
        </Box>

       { recentGuidelinesMessage.financialProtectionMessageId!=='' && recentGuidelinesMessage.status && (
        <div className='container p-0'>
          <div className='card outer-box-text border-0 card--'>
            <div className='outer-box-text-one'></div>
            {/* <div className='card-header'>
             
            </div> */}
            <div className='card-body pt-0 h-auto'>
            <h6 className='mt-2 text-white position-relative'>Financial Protection System</h6>
              <p><strong className='guide'>Guidelines : </strong><br/>
                {recentGuidelinesMessage.financialProtectionMessage}
              </p>
            </div>
          </div>
        </div>
        )}


        <div className="invoice-list-section">
          {!flag ?
            <div className='sub-content-sec recently-blog'>
              <InvoiceList setFlag={setFlag} updateRecord={getUpdateRecordValue}/>
            </div>
            :
            (
              <CreateInvoice setFlag={setFlag} updateRecord={updateValue}></CreateInvoice>
            )
          }
        </div>
      </Box>



    </div>
  );
}